<template>
  <HeaderLayout color='#0013C0'>
    <template v-slot:center>
      <div id="headerSearchBlock">
        <HeaderSearchFieldContainer :items="searchTargetList" />
      </div>
    </template>
    <template v-slot:right>
      <div class="mr-2">
        <SmallIconButton
          icon="mdi-lightning-bolt"
          @click="() => $router.push({ name: 'adminSystemInformations' })"
        />
      </div>
      <div class="mr-2">
        <SmallIconButton
          icon="mdi-help-circle-outline"
          @click="toSupportPage"
        />
      </div>
      <AccountMenuContainer>
        <router-link to="/admin/profiles">
          <ProfileListItem />
        </router-link>
        <router-link to="/admin/emails">
          <EmailListItem />
        </router-link>
        <router-link to="/admin/passwords">
          <PasswordListItem />
        </router-link>
      </AccountMenuContainer>
    </template>
  </HeaderLayout>
</template>

<script>
import SmallIconButton from '/src/components/uiParts/buttons/SmallIconButton'
import AccountMenuContainer from '/src/container/shared/Header/AccountMenuContainer'
import ProfileListItem from '/src/components/uiParts/ListItems/Profile'
import EmailListItem from '/src/components/uiParts/ListItems/Email'
import PasswordListItem from '/src/components/uiParts/ListItems/Password'
import HeaderSearchFieldContainer from '/src/container/shared/Header/HeaderSearchFieldContainer'
import { pageNameMapper } from '@/src/routers/admin'
import HeaderLayout from '/src/components/shared/HeaderLayout'

export default {
  name: 'AdminHeader',
  components: {
    HeaderLayout,
    HeaderSearchFieldContainer,
    PasswordListItem,
    EmailListItem,
    ProfileListItem,
    AccountMenuContainer,
    SmallIconButton
  },
  props: {
    color: {
      type: String,
      default: '#0013C0'
    }
  },
  computed: {
    searchTargetList () {
      return pageNameMapper
    }
  },
  methods: {
    toSupportPage () {
      window.open('https://support.b-cms.jp', '_blank')
    }
  }
}
</script>

<style></style>
